<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="ch02"></a><a id="page_5"></a><a class="nounderb" href="#/xhtml/content">AUGUST</a></h2>
<p class="imagecm1"><img alt="logo" height="45" src="images/common.jpg" width="60"/><a id="page_6"></a></p><a id="page_6">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch02.vue?306b0ca4